export const streetTypes = [
    'Aly',
    'Anx',
    'Arc',
    'Ave',
    'Bch',
    'Bg',
    'Bgs',
    'Blf',
    'Blfs',
    'Blvd',
    'Bnd',
    'Br',
    'Brdge',
    'Brg',
    'Brk',
    'Brks',
    'Btm',
    'Byp',
    'Byu',
    'Cir',
    'Cirs',
    'Clb',
    'Clf',
    'Clfs',
    'Cmn',
    'Cmns',
    'Cor',
    'Cors',
    'Cp',
    'Cpe',
    'Cres',
    'Crk',
    'Crse',
    'Crst',
    'Cswy',
    'Ct',
    'Ctr',
    'Ctrs',
    'Cts',
    'Curv',
    'Cv',
    'Cvs',
    'Cyn',
    'Dl',
    'Dm',
    'Dr',
    'Drs',
    'Dv',
    'Est',
    'Ests',
    'Expy',
    'Ext',
    'Exts',
    'Fall',
    'Fld',
    'Flds',
    'Fls',
    'Flt',
    'Flts',
    'Frd',
    'Frds',
    'Freeway',
    'Frg',
    'Frgs',
    'Frk',
    'Frks',
    'Frst',
    'Fry',
    'Ft',
    'Gdn',
    'Gdns',
    'Gln',
    'Glns',
    'Grn',
    'Grns',
    'Grv',
    'Grvs',
    'Gtwy',
    'Hbr',
    'Hbrs',
    'Highway',
    'Hl',
    'Hls',
    'Holw',
    'Hts',
    'Hvn',
    'Inlt',
    'Is',
    'Isle',
    'Iss',
    'Jct',
    'Jcts',
    'Knl',
    'Knls',
    'Ky',
    'Kys',
    'Lake',
    'Lakes',
    'Land',
    'Lck',
    'Lcks',
    'Ldg',
    'Lf',
    'Lgt',
    'Lgts',
    'Ln',
    'Lndg',
    'Loop',
    'Mall',
    'Mdw',
    'Mdws',
    'Mews',
    'Ml',
    'Mls',
    'Mnr',
    'Mnrs',
    'Msn',
    'Mt',
    'Mtn',
    'Mtns',
    'Mtwy',
    'Nck',
    'Opas',
    'Orch',
    'Oval',
    'Park',
    'Pass',
    'Path',
    'Pike',
    'Pine',
    'Pkwy',
    'Pl',
    'Pln',
    'Plns',
    'Plz',
    'Pne',
    'Pnes',
    'Pns',
    'Pr',
    'Prt',
    'Prts',
    'Psge',
    'Pt',
    'Pts',
    'Radl',
    'Ramp',
    'Rd',
    'Rdg',
    'Rdgs',
    'Rds',
    'Riv',
    'Rnch',
    'Row',
    'Rpd',
    'Rpds',
    'Rst',
    'Rte',
    'Rue',
    'Run',
    'Shl',
    'Shls',
    'Shr',
    'Shrs',
    'Skwy',
    'Smt',
    'Spg',
    'Spgs',
    'Spur',
    'Sq',
    'Sqs',
    'St',
    'Sta',
    'Stra',
    'Strm',
    'Sts',
    'Ter',
    'Tpke',
    'Trak',
    'Trce',
    'Trfy',
    'Trl',
    'Trlr',
    'Trwy',
    'Tunl',
    'Un',
    'Uns',
    'Upas',
    'Via',
    'Vis',
    'Vl',
    'Vlg',
    'Vlgs',
    'Vly',
    'Vlys',
    'Vw',
    'Vws',
    'Walk',
    'Wall',
    'Way',
    'Ways',
    'Wl',
    'Wls',
    'Xing',
    'Xrd',
    'Xrds',
    'None'
];

export const countyList = [
    'Travis',
    'Williamson',
    'Bastrop',
    'Caldwell',
    'Hays'
    // 'Bell',
    // 'Blanco',
    // 'Burnet',
    // 'Comal',
    // 'Fayette',
    // 'Gillespie',
    // 'Gonzales',
    // 'Guadalupe',
    // 'Lampasas',
    // 'Lee',
    // 'Llano',
    // 'McMullen',
    // 'Milam',
    // 'San Saba',
    // 'Anderson',
    // 'Andrews',
    // 'Angelina',
    // 'Aransas',
    // 'Archer',
    // 'Armstrong',
    // 'Atascosa',
    // 'Austin',
    // 'Bailey',
    // 'Bandera',
    // 'Baylor',
    // 'Bee',
    // 'Bexar',
    // 'Borden',
    // 'Bosque',
    // 'Bowie',
    // 'Brazoria',
    // 'Brazos',
    // 'Brewster',
    // 'Briscoe',
    // 'Brooks',
    // 'Brown',
    // 'Burleson',
    // 'Calhoun',
    // 'Callahan',
    // 'Cameron',
    // 'Camp',
    // 'Carson',
    // 'Cass',
    // 'Castro',
    // 'Chambers',
    // 'Cherokee',
    // 'Childress',
    // 'Chisum Isd',
    // 'Clay',
    // 'Cochran',
    // 'Coke',
    // 'Coleman',
    // 'Collin',
    // 'Collingsworth',
    // 'Colorado',
    // 'Comanche',
    // 'Concho',
    // 'Cooke',
    // 'Coryell',
    // 'Cottle',
    // 'Crane',
    // 'Crockett',
    // 'Crosby',
    // 'Culberson',
    // 'Dallam',
    // 'Dallas',
    // 'Dawson',
    // 'Deaf Smith',
    // 'Delta',
    // 'Denton',
    // 'DeWitt',
    // 'Dickens',
    // 'Dimmit',
    // 'Donley',
    // 'Duval',
    // 'Eastland',
    // 'Ector',
    // 'Edwards',
    // 'El Paso',
    // 'Ellis',
    // 'Erath',
    // 'Falls',
    // 'Fannin',
    // 'Fisher',
    // 'Floyd',
    // 'Foard',
    // 'Fort Bend',
    // 'Franklin',
    // 'Freestone',
    // 'Frio',
    // 'Gaines',
    // 'Galveston',
    // 'Garza',
    // 'Glasscock',
    // 'Goliad',
    // 'Gray',
    // 'Grayson',
    // 'Gregg',
    // 'Grimes',
    // 'Hale',
    // 'Hall',
    // 'Hamilton',
    // 'Hansford',
    // 'Hardeman',
    // 'Hardin',
    // 'Harris',
    // 'Harrison',
    // 'Hartley',
    // 'Haskell',
    // 'Hemphill',
    // 'Henderson',
    // 'Hidalgo',
    // 'Hill',
    // 'Hockley',
    // 'Hood',
    // 'Hopkins',
    // 'Houston',
    // 'Howard',
    // 'Hudspeth',
    // 'Hunt',
    // 'Hutchinson',
    // 'Irion',
    // 'Jack',
    // 'Jackson',
    // 'Jasper',
    // 'Jeff Davis',
    // 'Jefferson',
    // 'Jim Hogg',
    // 'Jim Wells',
    // 'Johnson',
    // 'Jones',
    // 'Karnes',
    // 'Kaufman',
    // 'Kendall',
    // 'Kenedy',
    // 'Kent',
    // 'Kerr',
    // 'Kimble',
    // 'King',
    // 'Kinney',
    // 'Kleberg',
    // 'Knox',
    // 'Knox County',
    // 'La Salle',
    // 'Lamar',
    // 'Lamb',
    // 'Lavaca',
    // 'Leon',
    // 'Liberty',
    // 'Limestone',
    // 'Lipscomb',
    // 'Live Oak',
    // 'Loving',
    // 'Lubbock',
    // 'Lynn',
    // 'Madison',
    // 'Marion',
    // 'Martin',
    // 'Mason',
    // 'Matagorda',
    // 'Maverick',
    // 'McCulloch',
    // 'McLennan',
    // 'Medina',
    // 'Menard',
    // 'Midland',
    // 'Mills',
    // 'Mitchell',
    // 'Montague',
    // 'Montgomery',
    // 'Moore',
    // 'Morris',
    // 'Motley',
    // 'Nacogdoches',
    // 'Navarro',
    // 'Newton',
    // 'Nolan',
    // 'Nueces',
    // 'Ochiltree',
    // 'Oldham',
    // 'Orange',
    // 'Palo Pinto',
    // 'Panola',
    // 'Parker',
    // 'Parmer',
    // 'Pecos',
    // 'Polk',
    // 'Potter',
    // 'Presidio',
    // 'Rains',
    // 'Randall',
    // 'Reagan',
    // 'Real',
    // 'Red River',
    // 'Reeves',
    // 'Refugio',
    // 'Roberts',
    // 'Robertson',
    // 'Rockwall',
    // 'Runnels',
    // 'Rusk',
    // 'Sabine',
    // 'San Augustine',
    // 'San Jacinto',
    // 'San Patricio',
    // 'Schleicher',
    // 'Scurry',
    // 'Shackelford',
    // 'Shelby',
    // 'Sherman',
    // 'Smith',
    // 'Somervell',
    // 'Starr',
    // 'Stephens',
    // 'Sterling',
    // 'Stonewall',
    // 'Sutton',
    // 'Swisher',
    // 'Tarrant',
    // 'Taylor',
    // 'Terrell',
    // 'Terry',
    // 'Throckmorton',
    // 'Titus',
    // 'Tom Green',
    // 'Trinity',
    // 'Tyler',
    // 'Upshur',
    // 'Upton',
    // 'Uvalde',
    // 'Val Verde',
    // 'Van Zandt',
    // 'Victoria',
    // 'Walker',
    // 'Waller',
    // 'Ward',
    // 'Washington',
    // 'Webb',
    // 'Wharton',
    // 'Wheeler',
    // 'Wichita',
    // 'Wilbarger',
    // 'Willacy',
    // 'Wilson',
    // 'Winkler',
    // 'Wise',
    // 'Wood',
    // 'Yoakum',
    // 'Young',
    // 'Zapata',
    // 'Zavala',
    // 'Out of State'
];

export const countryList = [
    'United States Of America',
    'Afghanistan',
    'Aland Islands',
    'Albania',
    'Algeria',
    'American Samoa',
    'Andorra',
    'Angola',
    'Anguilla',
    'Antarctica',
    'Antigua Barbuda',
    'Argentina',
    'Armenia',
    'Aruba',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bermuda',
    'Bhutan',
    'Bolivia, Plurinational State of Bolivia',
    'Bosnia Herzegovina',
    'Botswana',
    'Bouvet Island',
    'Brazil',
    'British Indian Ocean Territory',
    'Brunei Darussalam',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Cayman Islands',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Christmas Island',
    'Cocos (Keeling) Islands',
    'Colombia',
    'Comoros',
    'Congo',
    'Congo Democratic Republic',
    'Cook Islands',
    'Costa Rica',
    "Cote d'Ivoire",
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czech Republic',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Ethiopia',
    'Falkland Islands',
    'Faroe Islands',
    'Fiji',
    'Finland',
    'France',
    'French Guiana',
    'French Polynesia',
    'French Southern Territories',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Gibraltar',
    'Greece',
    'Greenland',
    'Grenada',
    'Guadeloupe',
    'Guam',
    'Guatemala',
    'Guernsey',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Heard And McDonald Islands',
    'Holy See (Vatican City)',
    'Honduras',
    'Hong Kong',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran, Islamic Republic of Iran',
    'Iraq',
    'Ireland',
    'Isle Of Man',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jersey',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    "Korea - North, the Democratic People's Republic of Korea",
    'Korea - South, the Republic of Korea',
    'Kuwait',
    'Kyrgyzstan',
    "Lao, Lao People's Democratic Republic",
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libyan Arab Jamahiriya, Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Macao',
    'Macedonia',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Martinique',
    'Mauritania',
    'Mauritius',
    'Mayotte',
    'Mexico',
    'Micronesia, Federated States of Micronesia',
    'Moldova, the Republic of Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Montserrat',
    'Morocco',
    'Mozambique',
    'Myanmar',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'Netherlands Antilles',
    'New Caledonia',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'Niue',
    'Norfolk Island',
    'Northern Mariana Islands',
    'Oman',
    'Other',
    'Pakistan',
    'Palau',
    'Palestinian Territory, State of Palestine',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Pitcairn',
    'Poland',
    'Portugal',
    'Puerto Rico',
    'Qatar',
    'Reunion',
    'Romania',
    'Russian Federation',
    'Rwanda',
    'Saint Barthelemy, Saint Barthélemy',
    'Saint Helena, Ascension and Tristan da Cunha Saint Helena',
    'Saint Kitts And Nevis',
    'Saint Lucia',
    'Saint Martin',
    'Saint Pierre And Miquelon',
    'Saint Vincent - Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome And Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Georgia, South Georgia/South Sandwich Islands',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Svalbard - Jan Mayen, Svalbard and Jan Mayen',
    'Swaziland',
    'Sweden',
    'Switzerland',
    'Syrian Arab Republic',
    'Taiwan',
    'Tajikistan',
    'Tanzania, United Republic of Tanzania',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tokelau',
    'Tonga',
    'Trinidad - Tobago, Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Turks - Caicos Islands',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom, United Kingdom of GB and N Ireland',
    'United States Minor Islands',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela, Bolivarian Republic of Venezuela',
    'Viet Nam',
    'Virgin Islands British',
    'Virgin Islands U.S.',
    'Wallis And Futuna',
    'Western Sahara',
    'Yemen',
    'Zambia',
    'Zimbabwe'
];

export const schoolData = [
    {
        id: 1,
        name: 'Alison',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 2,
        name: 'Andrews',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 3,
        name: 'Baldwin',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 4,
        name: 'Baranoff',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 5,
        name: 'Barrington',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 6,
        name: 'Barton Hills',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 7,
        name: 'Bear Creek',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 8,
        name: 'Becker',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 9,
        name: 'Blackshear',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 10,
        name: 'Blanton',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 11,
        name: 'Blazier',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 12,
        name: 'Boone',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 13,
        name: 'Bowie',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 14,
        name: 'Brentwood',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 15,
        name: 'Brooke',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 16,
        name: 'Brown',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 17,
        name: 'Brykerwoods',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 18,
        name: 'Campbell',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 19,
        name: 'Casey',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 20,
        name: 'Casis',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 21,
        name: 'Clayton',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 22,
        name: 'Cook',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 23,
        name: 'Cowan',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 24,
        name: 'Crockett',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 25,
        name: 'Cunningham',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 26,
        name: 'Davis',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 27,
        name: 'Dawson',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 28,
        name: 'Doss(Austin ISD)',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 29,
        name: 'Galindo',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 30,
        name: 'Govalle',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 31,
        name: 'Graham',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 32,
        name: 'Guerrero Thompson',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 33,
        name: 'Gullet',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 34,
        name: 'Harris',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 35,
        name: 'Hart',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 36,
        name: 'HighlandPark',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 37,
        name: 'Hill',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 38,
        name: 'Houston',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 39,
        name: 'Jordan',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 40,
        name: 'Joslin',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 41,
        name: 'Kiker',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 42,
        name: 'Kocurek',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 43,
        name: 'Langford',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 44,
        name: 'Lee',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 45,
        name: 'Linder',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 46,
        name: 'Maplewood',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 47,
        name: 'Mathews',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 48,
        name: 'McBee',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 49,
        name: 'Menchaca',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 50,
        name: 'Mendez',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 51,
        name: 'Metz',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 52,
        name: 'Mills',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 53,
        name: 'Murchison',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 54,
        name: 'Norman-Sims',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 55,
        name: 'Northeast',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 56,
        name: 'Oak Hill',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 57,
        name: 'Oak Springs',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 58,
        name: 'Odom',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 59,
        name: 'Ortega',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 60,
        name: 'Overton',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 61,
        name: 'Padron',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 62,
        name: 'Palm',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 63,
        name: 'Patton',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 64,
        name: 'Pease',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 65,
        name: 'Pecan Springs',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 66,
        name: 'Perez',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 67,
        name: 'Pickle',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 68,
        name: 'Pillow',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 69,
        name: 'Pleasant Hill',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 70,
        name: 'Reilly',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 71,
        name: 'Ridgetop',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 72,
        name: 'Rodriguez',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 73,
        name: 'Sanchez',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 74,
        name: 'Sims',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 75,
        name: 'St Elmo',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 76,
        name: 'Summitt',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 77,
        name: 'Sunset Valley',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 78,
        name: 'Travis',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 79,
        name: 'Travis Hts',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 80,
        name: 'Uphaus Early Childhood',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 81,
        name: 'Walnut Creek',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 82,
        name: 'Webb Primary',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 83,
        name: 'Widen',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 84,
        name: 'Williams',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 85,
        name: 'Winn',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 86,
        name: 'Wooldridge',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 87,
        name: 'Wooten',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 88,
        name: 'Zavala',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 89,
        name: 'Zilker',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 90,
        name: 'Bailey',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 91,
        name: 'Bedichek',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 92,
        name: 'Bertha Sadler Means',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 93,
        name: 'Burnet(Austin ISD)',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 94,
        name: 'Covington',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 95,
        name: 'Dobie (Austin ISD',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 96,
        name: 'Garcia',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 97,
        name: 'Gorzycki',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 98,
        name: 'Kealing',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 99,
        name: 'Lamar (Austin ISD)',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 100,
        name: 'Lively MS (Fulmore)',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 101,
        name: 'Martin',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 102,
        name: 'Mendez',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 103,
        name: 'Murchison',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 104,
        name: 'O Henry',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 105,
        name: 'Paredes',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 106,
        name: 'Pleasant Hill',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 107,
        name: 'Small',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 108,
        name: 'Travis',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 109,
        name: 'Webb',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 110,
        name: 'Pearce Middle',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 111,
        name: 'Dr. General Garwood Marshall',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 112,
        name: 'Akins',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 113,
        name: 'Anderson',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 114,
        name: 'Austin',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 115,
        name: 'Bowie',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 116,
        name: 'Crockett',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 117,
        name: 'Eastside Early College',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 118,
        name: 'Lyndon B Johnson',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 119,
        name: 'Mccallum',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 120,
        name: 'Navarro Early College',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 121,
        name: 'Northeast Early College',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 122,
        name: 'Travis',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Travis'
    },
    {
        id: 123,
        name: 'Coupland',
        level: 'Elementary',
        district: 'Coupland ISD',
        County: 'Travis'
    },
    {
        id: 124,
        name: 'Coupland Middle',
        level: 'Middle or Junior',
        district: 'Coupland ISD',
        County: 'Travis'
    },
    {
        id: 125,
        name: 'Taylor',
        level: 'Middle or Junior',
        district: 'Coupland ISD',
        County: 'Travis'
    },
    {
        id: 126,
        name: 'Taylor',
        level: 'High School',
        district: 'Coupland ISD',
        County: 'Travis'
    },
    {
        id: 127,
        name: 'Baty',
        level: 'Elementary',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 128,
        name: 'Creedmor',
        level: 'Elementary',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 129,
        name: 'Vel Valle',
        level: 'Elementary',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 130,
        name: 'Gilbert',
        level: 'Elementary',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 131,
        name: 'Hillcrest',
        level: 'Elementary',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 132,
        name: 'Hornsby-Dunlap',
        level: 'Elementary',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 133,
        name: 'Newton Collins',
        level: 'Elementary',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 134,
        name: 'Popham',
        level: 'Elementary',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 135,
        name: 'Smith',
        level: 'Elementary',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 136,
        name: 'Dailey',
        level: 'Middle or Junior',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 137,
        name: 'Del Valle',
        level: 'Middle or Junior',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 138,
        name: 'Ojeda',
        level: 'Middle or Junior',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 139,
        name: 'Smith',
        level: 'Middle or Junior',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 140,
        name: 'Del Valle',
        level: 'High School',
        district: 'Del Valle ISD',
        County: 'Travis'
    },
    {
        id: 141,
        name: 'Dripping Springs',
        level: 'Elementary',
        district: 'Dripping Springs ISD',
        County: 'Travis'
    },
    {
        id: 142,
        name: 'Rooster Springs',
        level: 'Elementary',
        district: 'Dripping Springs ISD',
        County: 'Travis'
    },
    {
        id: 143,
        name: 'Sycamor Springs',
        level: 'Elementary',
        district: 'Dripping Springs ISD',
        County: 'Travis'
    },
    {
        id: 144,
        name: 'Walnut Springs',
        level: 'Elementary',
        district: 'Dripping Springs ISD',
        County: 'Travis'
    },
    {
        id: 145,
        name: 'Cypress Springs',
        level: 'Elementary',
        district: 'Dripping Springs ISD',
        County: 'Travis'
    },
    {
        id: 146,
        name: 'Dripping Springs Middle',
        level: 'Middle or Junior',
        district: 'Dripping Springs ISD',
        County: 'Travis'
    },
    {
        id: 147,
        name: 'Sycamor Springs',
        level: 'Middle or Junior',
        district: 'Dripping Springs ISD',
        County: 'Travis'
    },
    {
        id: 148,
        name: 'Dripping Springs',
        level: 'High School',
        district: 'Dripping Springs ISD',
        County: 'Travis'
    },
    {
        id: 149,
        name: 'Barton Creek',
        level: 'Elementary',
        district: 'Eanes ISD',
        County: 'Travis'
    },
    {
        id: 150,
        name: 'Bridge Point',
        level: 'Elementary',
        district: 'Eanes ISD',
        County: 'Travis'
    },
    {
        id: 151,
        name: 'Cedar Creek (Eanes ISD)',
        level: 'Elementary',
        district: 'Eanes ISD',
        County: 'Travis'
    },
    {
        id: 152,
        name: 'Eanes',
        level: 'Elementary',
        district: 'Eanes ISD',
        County: 'Travis'
    },
    {
        id: 153,
        name: 'Forest Trail',
        level: 'Elementary',
        district: 'Eanes ISD',
        County: 'Travis'
    },
    {
        id: 154,
        name: 'Valley View',
        level: 'Elementary',
        district: 'Eanes ISD',
        County: 'Travis'
    },
    {
        id: 155,
        name: 'Cedar Creek',
        level: 'Middle or Junior',
        district: 'Eanes ISD',
        County: 'Travis'
    },
    {
        id: 156,
        name: 'Hill Country',
        level: 'Middle or Junior',
        district: 'Eanes ISD',
        County: 'Travis'
    },
    {
        id: 157,
        name: 'West Ridge',
        level: 'Middle or Junior',
        district: 'Eanes ISD',
        County: 'Travis'
    },
    {
        id: 158,
        name: 'Cedar Creek',
        level: 'High School',
        district: 'Eanes ISD',
        County: 'Travis'
    },
    {
        id: 159,
        name: 'Westlake',
        level: 'High School',
        district: 'Eanes ISD',
        County: 'Travis'
    },
    {
        id: 160,
        name: 'Booker T Washington',
        level: 'Elementary',
        district: 'Elgin ISD',
        County: 'Travis'
    },
    {
        id: 161,
        name: 'Elgin',
        level: 'Elementary',
        district: 'Elgin ISD',
        County: 'Travis'
    },
    {
        id: 162,
        name: 'Neiding',
        level: 'Elementary',
        district: 'Elgin ISD',
        County: 'Travis'
    },
    {
        id: 163,
        name: 'Lexington School',
        level: 'Elementary',
        district: 'Elgin ISD',
        County: 'Travis'
    },
    {
        id: 164,
        name: 'Harvest Ridge',
        level: 'Elementary',
        district: 'Elgin ISD',
        County: 'Travis'
    },
    {
        id: 165,
        name: 'Elgin',
        level: 'Middle or Junior',
        district: 'Elgin ISD',
        County: 'Travis'
    },
    {
        id: 166,
        name: 'Elgin',
        level: 'High School',
        district: 'Elgin ISD',
        County: 'Travis'
    },
    {
        id: 167,
        name: 'Blanco Vista Elem',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 168,
        name: 'Buda',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 169,
        name: 'Camino Real',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 170,
        name: 'Carpenter Hill',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 171,
        name: 'Elm Grove',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 172,
        name: 'Hemphill',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 173,
        name: 'Kyle',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 174,
        name: 'Laura B Negley',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 175,
        name: 'Ralph Pfluger',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 176,
        name: 'Science Hall',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 177,
        name: 'Sunfield',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 178,
        name: 'Susie Fuentes',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 179,
        name: 'Tobias',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 180,
        name: 'Tom Green',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 181,
        name: 'Uhland',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 182,
        name: 'Jim Cullen',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 183,
        name: 'Armando Chapa',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 184,
        name: 'D J Red Simon',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 185,
        name: 'Eric Dahlstrom',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 186,
        name: 'Laura B Wallace',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 187,
        name: 'McCormick',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 188,
        name: 'R C Barton',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 189,
        name: 'Jack C Hays',
        level: 'High School',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 190,
        name: 'Johnson High School',
        level: 'High School',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 191,
        name: 'Lehman',
        level: 'High School',
        district: 'Hays CISD',
        County: 'Travis'
    },
    {
        id: 192,
        name: 'Lyndon B Johnson',
        level: 'Elementary',
        district: 'Johnson City ISD',
        County: 'Travis'
    },
    {
        id: 193,
        name: 'Lyndon B Johnson',
        level: 'Middle or Junior',
        district: 'Johnson City ISD',
        County: 'Travis'
    },
    {
        id: 194,
        name: 'Lyndon B Johnson (Johnson City ISD)',
        level: 'High School',
        district: 'Johnson City ISD',
        County: 'Travis'
    },
    {
        id: 195,
        name: 'Lago Vista',
        level: 'Elementary',
        district: 'Lago Vista ISD',
        County: 'Travis'
    },
    {
        id: 196,
        name: 'Lago Vista',
        level: 'Middle or Junior',
        district: 'Lago Vista ISD',
        County: 'Travis'
    },
    {
        id: 197,
        name: 'Lago Vista',
        level: 'High School',
        district: 'Lago Vista ISD',
        County: 'Travis'
    },
    {
        id: 198,
        name: 'Bee Cave',
        level: 'Elementary',
        district: 'Lake Travis ISD',
        County: 'Travis'
    },
    {
        id: 199,
        name: 'Lake Pointe',
        level: 'Elementary',
        district: 'Lake Travis ISD',
        County: 'Travis'
    },
    {
        id: 200,
        name: 'Lake Travis',
        level: 'Elementary',
        district: 'Lake Travis ISD',
        County: 'Travis'
    },
    {
        id: 201,
        name: 'Lakeway',
        level: 'Elementary',
        district: 'Lake Travis ISD',
        County: 'Travis'
    },
    {
        id: 202,
        name: 'Rough Hollow',
        level: 'Elementary',
        district: 'Lake Travis ISD',
        County: 'Travis'
    },
    {
        id: 203,
        name: 'Serene Hills',
        level: 'Elementary',
        district: 'Lake Travis ISD',
        County: 'Travis'
    },
    {
        id: 204,
        name: 'West Cypress Hills',
        level: 'Elementary',
        district: 'Lake Travis ISD',
        County: 'Travis'
    },
    {
        id: 205,
        name: 'Bee Cave Middle School',
        level: 'Middle or Junior',
        district: 'Lake Travis ISD',
        County: 'Travis'
    },
    {
        id: 206,
        name: 'Hudson Bend',
        level: 'Middle or Junior',
        district: 'Lake Travis ISD',
        County: 'Travis'
    },
    {
        id: 207,
        name: 'Lake Travis',
        level: 'Middle or Junior',
        district: 'Lake Travis ISD',
        County: 'Travis'
    },
    {
        id: 208,
        name: 'Lake Travis',
        level: 'High School',
        district: 'Lake Travis ISD',
        County: 'Travis'
    },
    {
        id: 209,
        name: 'Ada Mae Faubion',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 210,
        name: 'Akin',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 211,
        name: 'Bagdad',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 212,
        name: 'Block House',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 213,
        name: 'Camacho',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 214,
        name: 'CC Mason',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 215,
        name: 'Charlotte Cox',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 216,
        name: 'Deer Creek',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 217,
        name: 'Grandview Hills',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 218,
        name: 'Jim Plain',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 219,
        name: 'Knowles',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 220,
        name: 'Larkspur',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 221,
        name: 'Laura Welch Bush',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 222,
        name: 'Lois F Giddens',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 223,
        name: 'North',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 224,
        name: 'Parkside',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 225,
        name: 'Pauline Naumann',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 226,
        name: 'Pleasant Hill',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 227,
        name: 'Pleasant Hill (Leander ISD)',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 228,
        name: 'Reed',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 229,
        name: 'River Place',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 230,
        name: 'River Ridge',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 231,
        name: 'Ronald Reagan',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 232,
        name: 'Rutledge',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 233,
        name: 'Steiner Ranch',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 234,
        name: 'Tarvin',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 235,
        name: 'Westside',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 236,
        name: 'Whitestone',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 237,
        name: 'William J Winkley',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 238,
        name: 'Hisle',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 239,
        name: 'Canyon Ridge',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 240,
        name: 'Cedar Park',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 241,
        name: 'Danielson',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 242,
        name: 'Four Points',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 243,
        name: 'Henry',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 244,
        name: 'Know Wiley',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 245,
        name: 'Leander Middle',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 246,
        name: 'Pleasant Hill',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 247,
        name: 'Running Brushy',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 248,
        name: 'Stiles',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 249,
        name: 'Westside',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 250,
        name: 'Cedar Park',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 251,
        name: 'Glenn',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 252,
        name: 'Leander High',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 253,
        name: 'Rouse',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 254,
        name: 'Vandegrift',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 255,
        name: 'Vista Ridge',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Travis'
    },
    {
        id: 256,
        name: 'Blake Manor',
        level: 'Elementary',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 257,
        name: 'Bluebonnet Trail',
        level: 'Elementary',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 258,
        name: 'Decker',
        level: 'Elementary',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 259,
        name: 'Lagos',
        level: 'Elementary',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 260,
        name: 'Manor',
        level: 'Elementary',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 261,
        name: 'Oak Meadows',
        level: 'Elementary',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 262,
        name: 'Pioneer Crossing',
        level: 'Elementary',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 263,
        name: 'Presidential Meadows',
        level: 'Elementary',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 264,
        name: 'ShadowGlen',
        level: 'Elementary',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 265,
        name: 'Decker',
        level: 'Middle or Junior',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 266,
        name: 'Manor (Manor ISD)',
        level: 'Middle or Junior',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 267,
        name: 'Manor',
        level: 'High School',
        district: 'Manor ISD',
        County: 'Travis'
    },
    {
        id: 268,
        name: 'Colt',
        level: 'Elementary',
        district: 'Marble Falls ISD',
        County: 'Travis'
    },
    {
        id: 269,
        name: 'Highland Lake',
        level: 'Elementary',
        district: 'Marble Falls ISD',
        County: 'Travis'
    },
    {
        id: 270,
        name: 'Marble Falls',
        level: 'Elementary',
        district: 'Marble Falls ISD',
        County: 'Travis'
    },
    {
        id: 271,
        name: 'Spicewood (Marble Falls ISD)',
        level: 'Elementary',
        district: 'Marble Falls ISD',
        County: 'Travis'
    },
    {
        id: 272,
        name: 'Marble Falls',
        level: 'Middle or Junior',
        district: 'Marble Falls ISD',
        County: 'Travis'
    },
    {
        id: 273,
        name: 'Marble Falls',
        level: 'High School',
        district: 'Marble Falls ISD',
        County: 'Travis'
    },
    {
        id: 274,
        name: 'Barron',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 275,
        name: 'Brookhollow',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 276,
        name: 'Caldwell',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 277,
        name: 'Carpente Elementary',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 278,
        name: 'Copperfield',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 279,
        name: 'Dearing',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 280,
        name: 'Delco Primary',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 281,
        name: 'Dessau',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 282,
        name: 'HighlandPark',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 283,
        name: 'Highland Park (Pflugerville ISD)',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 284,
        name: 'Mott',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 285,
        name: 'Murchison',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 286,
        name: 'Northwest',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 287,
        name: 'Parmer Lane',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 288,
        name: 'Pflugerville',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 289,
        name: 'Riojas',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 290,
        name: 'River Oaks',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 291,
        name: 'Rowe Lane',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 292,
        name: 'Springhill',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 293,
        name: 'Timmerman',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 294,
        name: 'Wieland',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 295,
        name: 'Windermere',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 296,
        name: 'Windermere Primary',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 297,
        name: 'Hidden lake',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 298,
        name: 'Bohls',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 299,
        name: 'Cele',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 300,
        name: 'Dessau',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 301,
        name: 'Kelly Lane',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 302,
        name: 'Murchison',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 303,
        name: 'Park Crest',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 304,
        name: 'Pflugerville',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 305,
        name: 'Westview',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 306,
        name: 'Hendrickson',
        level: 'High School',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 307,
        name: 'John B Connally',
        level: 'High School',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 308,
        name: 'Pflugerville',
        level: 'High School',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 309,
        name: 'Weiss',
        level: 'High School',
        district: 'Pflugerville ISD',
        County: 'Travis'
    },
    {
        id: 310,
        name: 'Anderson Mill',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 311,
        name: 'Blackland Pairie',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 312,
        name: 'Bluebonnet',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 313,
        name: 'Brushy Creek',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 314,
        name: 'Cactus Ranch',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 315,
        name: 'Caldwell Heights',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 316,
        name: 'Canyon Creek',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 317,
        name: 'Caraway',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 318,
        name: 'Cedar Valley',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 319,
        name: 'Chandler Oaks',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 320,
        name: 'Chisholm Trail',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 321,
        name: 'Claude Berkman',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 322,
        name: 'Deep Wood',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 323,
        name: 'Double File Trail',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 324,
        name: 'Elsa England',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 325,
        name: 'Fern Bluff',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 326,
        name: 'Forest Creek',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 327,
        name: 'Forest North',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 328,
        name: 'Gattis',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 329,
        name: 'Great Oaks',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 330,
        name: 'Herrington',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 331,
        name: 'Joe Lee Johnson',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 332,
        name: 'Jollyville',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 333,
        name: 'Laurel Mountain',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 334,
        name: 'Live Oak',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 335,
        name: 'Callison',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 336,
        name: 'Old Town',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 337,
        name: 'Patsy Sommer',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 338,
        name: 'Pond Springs',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 339,
        name: 'Purple Sage',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 340,
        name: 'Spicewood',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 341,
        name: 'Teravista',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 342,
        name: 'Union Hill',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 343,
        name: 'Vic Robertson',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 344,
        name: 'Wells Branch',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 345,
        name: 'Xenia Voigt',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 346,
        name: 'Redbud',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 347,
        name: 'Canyon Vista',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 348,
        name: 'CD Fulkes',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 349,
        name: 'Cedar Valley',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 350,
        name: 'Chisholm Trail',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 351,
        name: 'CPL Robert P Hernandez',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 352,
        name: 'Deerpark',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 353,
        name: 'Hopewell',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 354,
        name: 'Noel Grisham',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 355,
        name: 'Pearson Ranch',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 356,
        name: 'Ridgeview',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 357,
        name: 'Walsh',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 358,
        name: 'Cedar Ridge',
        level: 'High School',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 359,
        name: 'McNeil',
        level: 'High School',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 360,
        name: 'Round Rock',
        level: 'High School',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 361,
        name: 'Story Point',
        level: 'High School',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 362,
        name: 'Westwood',
        level: 'High School',
        district: 'Round Rock ISD',
        County: 'Travis'
    },
    {
        id: 363,
        name: 'Outside district',
        level: 'Elementary',
        district: 'Montessori For All',
        County: 'Travis'
    },
    {
        id: 364,
        name: 'Outside district',
        level: 'Middle or Junior',
        district: 'Montessori For All',
        County: 'Travis'
    },
    {
        id: 365,
        name: 'Outside district',
        level: 'High School',
        district: 'Montessori For All',
        County: 'Travis'
    },
    {
        id: 366,
        name: 'Outside district',
        level: 'Elementary',
        district: 'Nyos Charter School',
        County: 'Travis'
    },
    {
        id: 367,
        name: 'Outside district',
        level: 'Middle or Junior',
        district: 'Nyos Charter School',
        County: 'Travis'
    },
    {
        id: 368,
        name: 'Outside district',
        level: 'High School',
        district: 'Nyos Charter School',
        County: 'Travis'
    },
    {
        id: 369,
        name: 'Bartlett',
        level: 'Elementary',
        district: 'Bartlett ISD',
        County: 'Williamson'
    },
    {
        id: 370,
        name: 'Bartlett',
        level: 'Middle or Junior',
        district: 'Bartlett ISD',
        County: 'Williamson'
    },
    {
        id: 371,
        name: 'Bartlett',
        level: 'High School',
        district: 'Bartlett ISD',
        County: 'Williamson'
    },
    {
        id: 372,
        name: 'Bertram',
        level: 'Elementary',
        district: 'Burnet ISD',
        County: 'Williamson'
    },
    {
        id: 373,
        name: 'Burnet',
        level: 'Elementary',
        district: 'Burnet ISD',
        County: 'Williamson'
    },
    {
        id: 374,
        name: 'RJ Richey',
        level: 'Elementary',
        district: 'Burnet ISD',
        County: 'Williamson'
    },
    {
        id: 375,
        name: 'Shady Grove',
        level: 'Elementary',
        district: 'Burnet ISD',
        County: 'Williamson'
    },
    {
        id: 376,
        name: 'Burnet (Burnet ISD)',
        level: 'Middle or Junior',
        district: 'Burnet ISD',
        County: 'Williamson'
    },
    {
        id: 377,
        name: 'Burnet',
        level: 'High School',
        district: 'Burnet ISD',
        County: 'Williamson'
    },
    {
        id: 378,
        name: 'Coupland',
        level: 'Elementary',
        district: 'Coupland ISD',
        County: 'Williamson'
    },
    {
        id: 379,
        name: 'Coupland Middle',
        level: 'Middle or Junior',
        district: 'Coupland ISD',
        County: 'Williamson'
    },
    {
        id: 380,
        name: 'Taylor',
        level: 'Middle or Junior',
        district: 'Coupland ISD',
        County: 'Williamson'
    },
    {
        id: 381,
        name: 'Taylor',
        level: 'High School',
        district: 'Coupland ISD',
        County: 'Williamson'
    },
    {
        id: 382,
        name: 'Florence',
        level: 'Elementary',
        district: 'Florence ISD',
        County: 'Williamson'
    },
    {
        id: 383,
        name: 'Florence',
        level: 'Middle or Junior',
        district: 'Florence ISD',
        County: 'Williamson'
    },
    {
        id: 384,
        name: 'Florence',
        level: 'High School',
        district: 'Florence ISD',
        County: 'Williamson'
    },
    {
        id: 385,
        name: 'Annie Purl',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 386,
        name: 'Carver',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 387,
        name: 'Frost',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 388,
        name: 'James E Mitchell',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 389,
        name: 'Jo Ann Ford',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 390,
        name: 'N/A (Suncity)',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 391,
        name: 'Pat Cooper',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 392,
        name: 'Raye McCoy',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 393,
        name: 'Village EL',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 394,
        name: 'Williams',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 395,
        name: 'Wolf Ranch Elementary',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 396,
        name: 'San Gabriel',
        level: 'Elementary',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 397,
        name: 'Charles A Forbes',
        level: 'Middle or Junior',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 398,
        name: 'Douglas Benold',
        level: 'Middle or Junior',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 399,
        name: 'James Tippit',
        level: 'Middle or Junior',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 400,
        name: 'N/A (Suncity)',
        level: 'Middle or Junior',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 401,
        name: 'Wagner',
        level: 'Middle or Junior',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 402,
        name: 'East View',
        level: 'High School',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 403,
        name: 'Georgetown',
        level: 'High School',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 404,
        name: 'N/A (Suncity)',
        level: 'High School',
        district: 'Georgetown ISD',
        County: 'Williamson'
    },
    {
        id: 405,
        name: 'Granger',
        level: 'Elementary',
        district: 'Granger ISD',
        County: 'Williamson'
    },
    {
        id: 406,
        name: 'Granger',
        level: 'Middle or Junior',
        district: 'Granger ISD',
        County: 'Williamson'
    },
    {
        id: 407,
        name: 'Granger',
        level: 'High School',
        district: 'Granger ISD',
        County: 'Williamson'
    },
    {
        id: 408,
        name: 'Cottonwood Creek',
        level: 'Elementary',
        district: 'Hutto ISD',
        County: 'Williamson'
    },
    {
        id: 409,
        name: 'Howard Norman',
        level: 'Elementary',
        district: 'Hutto ISD',
        County: 'Williamson'
    },
    {
        id: 410,
        name: 'Hutto',
        level: 'Elementary',
        district: 'Hutto ISD',
        County: 'Williamson'
    },
    {
        id: 411,
        name: 'Benjamin Doc Kerley Elementary',
        level: 'Elementary',
        district: 'Hutto ISD',
        County: 'Williamson'
    },
    {
        id: 412,
        name: 'Nadine Johnson',
        level: 'Elementary',
        district: 'Hutto ISD',
        County: 'Williamson'
    },
    {
        id: 413,
        name: 'Ray Elementary',
        level: 'Elementary',
        district: 'Hutto ISD',
        County: 'Williamson'
    },
    {
        id: 414,
        name: 'Veterans Hill',
        level: 'Elementary',
        district: 'Hutto ISD',
        County: 'Williamson'
    },
    {
        id: 415,
        name: 'Farley',
        level: 'Middle or Junior',
        district: 'Hutto ISD',
        County: 'Williamson'
    },
    {
        id: 416,
        name: 'Hutto',
        level: 'Middle or Junior',
        district: 'Hutto ISD',
        County: 'Williamson'
    },
    {
        id: 417,
        name: 'Gus Almquist',
        level: 'Middle or Junior',
        district: 'Hutto ISD',
        County: 'Williamson'
    },
    {
        id: 418,
        name: 'Hutto',
        level: 'High School',
        district: 'Hutto ISD',
        County: 'Williamson'
    },
    {
        id: 419,
        name: 'Igo',
        level: 'Elementary',
        district: 'Jarrell ISD',
        County: 'Williamson'
    },
    {
        id: 420,
        name: 'Jarrell',
        level: 'Elementary',
        district: 'Jarrell ISD',
        County: 'Williamson'
    },
    {
        id: 421,
        name: 'Jarrell Int',
        level: 'Elementary',
        district: 'Jarrell ISD',
        County: 'Williamson'
    },
    {
        id: 422,
        name: 'N/A (Suncity)',
        level: 'Elementary',
        district: 'Jarrell ISD',
        County: 'Williamson'
    },
    {
        id: 423,
        name: 'Double Creek',
        level: 'Elementary',
        district: 'Jarrell ISD',
        County: 'Williamson'
    },
    {
        id: 424,
        name: 'Jarrell',
        level: 'Middle or Junior',
        district: 'Jarrell ISD',
        County: 'Williamson'
    },
    {
        id: 425,
        name: 'N/A (Suncity)',
        level: 'Middle or Junior',
        district: 'Jarrell ISD',
        County: 'Williamson'
    },
    {
        id: 426,
        name: 'Jarrell',
        level: 'High School',
        district: 'Jarrell ISD',
        County: 'Williamson'
    },
    {
        id: 427,
        name: 'N/A (Suncity)',
        level: 'High School',
        district: 'Jarrell ISD',
        County: 'Williamson'
    },
    {
        id: 428,
        name: 'Ada Mae Faubion',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 429,
        name: 'Akin',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 430,
        name: 'Bagdad',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 431,
        name: 'Block House',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 432,
        name: 'Camacho',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 433,
        name: 'CC Mason',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 434,
        name: 'Charlotte Cox',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 435,
        name: 'Cypress',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 436,
        name: 'Deer Creek',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 437,
        name: 'Grandview Hills',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 438,
        name: 'Jim Plain',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 439,
        name: 'Knowles',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 440,
        name: 'Larkspur',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 441,
        name: 'Laura Welch Bush',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 442,
        name: 'Lois F Giddens',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 443,
        name: 'North',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 444,
        name: 'Parkside',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 445,
        name: 'Pauline Naumann',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 446,
        name: 'Pleasant Hill',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 447,
        name: 'Pleasant Hill (Leander ISD)',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 448,
        name: 'Reed',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 449,
        name: 'River Place',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 450,
        name: 'River Ridge',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 451,
        name: 'Ronald Reagan',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 452,
        name: 'Rutledge',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 453,
        name: 'Steiner Ranch',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 454,
        name: 'Tarvin',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 455,
        name: 'Westside',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 456,
        name: 'Whitestone',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 457,
        name: 'William J Winkley',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 458,
        name: 'Hisle',
        level: 'Elementary',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 459,
        name: 'Canyon Ridge',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 460,
        name: 'Cedar Park',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 461,
        name: 'Danielson',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 462,
        name: 'Four Points',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 463,
        name: 'Henry',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 464,
        name: 'Knox Wiley',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 465,
        name: 'Leander Middle',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 466,
        name: 'Pleasant Hill',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 467,
        name: 'Running Brushy',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 468,
        name: 'Stiles',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 469,
        name: 'Westside',
        level: 'Middle or Junior',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 470,
        name: 'Cedar Park',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 471,
        name: 'Glenn',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 472,
        name: 'Leander High',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 473,
        name: 'Rouse',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 474,
        name: 'Vandegrift',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 475,
        name: 'Vista Ridge',
        level: 'High School',
        district: 'Leander ISD',
        County: 'Williamson'
    },
    {
        id: 476,
        name: 'Lexington',
        level: 'Elementary',
        district: 'Lexington ISD',
        County: 'Williamson'
    },
    {
        id: 477,
        name: 'Lexington',
        level: 'Middle or Junior',
        district: 'Lexington ISD',
        County: 'Williamson'
    },
    {
        id: 478,
        name: 'Lexington',
        level: 'High School',
        district: 'Lexington ISD',
        County: 'Williamson'
    },
    {
        id: 479,
        name: 'Bill Burden',
        level: 'Elementary',
        district: 'Liberty Hill ISD',
        County: 'Williamson'
    },
    {
        id: 480,
        name: 'Liberty Hill',
        level: 'Elementary',
        district: 'Liberty Hill ISD',
        County: 'Williamson'
    },
    {
        id: 481,
        name: 'Rancho Sienna',
        level: 'Elementary',
        district: 'Liberty Hill ISD',
        County: 'Williamson'
    },
    {
        id: 482,
        name: 'Santa Rita',
        level: 'Elementary',
        district: 'Liberty Hill ISD',
        County: 'Williamson'
    },
    {
        id: 483,
        name: 'Louine Noble',
        level: 'Elementary',
        district: 'Liberty Hill ISD',
        County: 'Williamson'
    },
    {
        id: 484,
        name: 'Bar W',
        level: 'Elementary',
        district: 'Liberty Hill ISD',
        County: 'Williamson'
    },
    {
        id: 485,
        name: 'Tierra Rosa',
        level: 'Elementary',
        district: 'Liberty Hill ISD',
        County: 'Williamson'
    },
    {
        id: 486,
        name: 'LIberty Hill Intermediate',
        level: 'Middle or Junior',
        district: 'Liberty Hill ISD',
        County: 'Williamson'
    },
    {
        id: 487,
        name: 'Liberty Hill Middle',
        level: 'Middle or Junior',
        district: 'Liberty Hill ISD',
        County: 'Williamson'
    },
    {
        id: 488,
        name: 'Santa Rita Middle',
        level: 'Middle or Junior',
        district: 'Liberty Hill ISD',
        County: 'Williamson'
    },
    {
        id: 489,
        name: 'Liberty hill',
        level: 'High School',
        district: 'Liberty Hill ISD',
        County: 'Williamson'
    },
    {
        id: 490,
        name: 'Barron',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 491,
        name: 'Brookhollow',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 492,
        name: 'Caldwell',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 493,
        name: 'Carpente Elementary',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 494,
        name: 'Copperfield',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 495,
        name: 'Dearing',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 496,
        name: 'Delco Primary',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 497,
        name: 'Dessau',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 498,
        name: 'HighlandPark',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 499,
        name: 'Highland Park (Pflugerville ISD)',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 500,
        name: 'Mott',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 501,
        name: 'Murchison',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 502,
        name: 'Northwest',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 503,
        name: 'Parmer Lane',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 504,
        name: 'Pflugerville',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 505,
        name: 'Riojas',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 506,
        name: 'River Oaks',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 507,
        name: 'Rowe Lane',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 508,
        name: 'Springhill',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 509,
        name: 'Timmerman',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 510,
        name: 'Wieland',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 511,
        name: 'Windermere',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 512,
        name: 'Windermere Primary',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 513,
        name: 'Hidden lake',
        level: 'Elementary',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 514,
        name: 'Bohls',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 515,
        name: 'Cele',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 516,
        name: 'Dessau',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 517,
        name: 'Kelly Lane',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 518,
        name: 'Murchison',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 519,
        name: 'Park Crest',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 520,
        name: 'Pflugerville',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 521,
        name: 'Westview',
        level: 'Middle or Junior',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 522,
        name: 'Hendrickson',
        level: 'High School',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 523,
        name: 'John B Connally',
        level: 'High School',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 524,
        name: 'Pflugerville',
        level: 'High School',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 525,
        name: 'Weiss',
        level: 'High School',
        district: 'Pflugerville ISD',
        County: 'Williamson'
    },
    {
        id: 526,
        name: 'Rockdale',
        level: 'Elementary',
        district: 'Rockdale ISD',
        County: 'Williamson'
    },
    {
        id: 527,
        name: 'Rockdale',
        level: 'Middle or Junior',
        district: 'Rockdale ISD',
        County: 'Williamson'
    },
    {
        id: 528,
        name: 'Rockdale',
        level: 'High School',
        district: 'Rockdale ISD',
        County: 'Williamson'
    },
    {
        id: 529,
        name: 'Anderson Mill',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 530,
        name: 'Blackland Prairie',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 531,
        name: 'Bluebonnet',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 532,
        name: 'Brushy Creek',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 533,
        name: 'Cactus Ranch',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 534,
        name: 'Caldwell Heights',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 535,
        name: 'Canyon Creek',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 536,
        name: 'Caraway',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 537,
        name: 'Cedar Valley',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 538,
        name: 'Chandler Oaks',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 539,
        name: 'Chrisholm Trail',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 540,
        name: 'Claude Berkman',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 541,
        name: 'Deep Wood',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 542,
        name: 'Double File Trail',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 543,
        name: 'Elsa England',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 544,
        name: 'Fern Bluff',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 545,
        name: 'Forest Creek',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 546,
        name: 'Forest North',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 547,
        name: 'Gattis',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 548,
        name: 'Great Oaks',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 549,
        name: 'Herrington',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 550,
        name: 'Joe Lee Johnson',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 551,
        name: 'Jollyville',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 552,
        name: 'Laurel Mountain',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 553,
        name: 'Live Oak',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 554,
        name: 'Callison',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 555,
        name: 'Old Town',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 556,
        name: 'Patsy Sommer',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 557,
        name: 'Pond Springs',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 558,
        name: 'Purple Sage',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 559,
        name: 'Spicewood',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 560,
        name: 'Teravista',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 561,
        name: 'Union Hill',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 562,
        name: 'Vic Robertson',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 563,
        name: 'Wells Branch',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 564,
        name: 'Xenia Voigt',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 565,
        name: 'Redbud',
        level: 'Elementary',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 566,
        name: 'Canyon Vista',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 567,
        name: 'CD Fulkes',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 568,
        name: 'Cedar Valley',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 569,
        name: 'Chrisholm Trail',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 570,
        name: 'CPL Robert P Hernandez',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 571,
        name: 'Deerpark',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 572,
        name: 'Hopewell',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 573,
        name: 'Noel Grisham',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 574,
        name: 'Rearson Ranch',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 575,
        name: 'Ridgeview',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 576,
        name: 'Walsh',
        level: 'Middle or Junior',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 577,
        name: 'Cedar Ridge',
        level: 'High School',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 578,
        name: 'McNeil',
        level: 'High School',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 579,
        name: 'Round Rock',
        level: 'High School',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 580,
        name: 'Stony Point',
        level: 'High School',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 581,
        name: 'Westwood',
        level: 'High School',
        district: 'Round Rock ISD',
        County: 'Williamson'
    },
    {
        id: 582,
        name: 'Even Star',
        level: 'Elementary',
        district: 'Taylor ISD',
        County: 'Williamson'
    },
    {
        id: 583,
        name: 'Main Street Int',
        level: 'Elementary',
        district: 'Taylor ISD',
        County: 'Williamson'
    },
    {
        id: 584,
        name: 'Naomi Pasemann',
        level: 'Elementary',
        district: 'Taylor ISD',
        County: 'Williamson'
    },
    {
        id: 585,
        name: 'Northside',
        level: 'Elementary',
        district: 'Taylor ISD',
        County: 'Williamson'
    },
    {
        id: 586,
        name: 'TH Johnson',
        level: 'Elementary',
        district: 'Taylor ISD',
        County: 'Williamson'
    },
    {
        id: 587,
        name: 'Taylor',
        level: 'Middle or Junior',
        district: 'Taylor ISD',
        County: 'Williamson'
    },
    {
        id: 588,
        name: 'Taylor',
        level: 'High School',
        district: 'Taylor ISD',
        County: 'Williamson'
    },
    {
        id: 589,
        name: 'Thorndale',
        level: 'Elementary',
        district: 'Thorndale ISD',
        County: 'Williamson'
    },
    {
        id: 590,
        name: 'Thorndale',
        level: 'Middle or Junior',
        district: 'Thorndale ISD',
        County: 'Williamson'
    },
    {
        id: 591,
        name: 'Thorndale',
        level: 'High School',
        district: 'Thorndale ISD',
        County: 'Williamson'
    },
    {
        id: 592,
        name: 'Thrall',
        level: 'Elementary',
        district: 'Thrall ISD',
        County: 'Williamson'
    },
    {
        id: 593,
        name: 'Thrall',
        level: 'Middle or Junior',
        district: 'Thrall ISD',
        County: 'Williamson'
    },
    {
        id: 594,
        name: 'Thrall',
        level: 'High School',
        district: 'Thrall ISD',
        County: 'Williamson'
    },
    {
        id: 595,
        name: 'Outside district',
        level: 'Elementary',
        district: 'Goodwater Montessori School',
        County: 'Williamson'
    },
    {
        id: 596,
        name: 'Outside district',
        level: 'Middle or Junior',
        district: 'Goodwater Montessori School',
        County: 'Williamson'
    },
    {
        id: 597,
        name: 'Outside district',
        level: 'High School',
        district: 'Goodwater Montessori School',
        County: 'Williamson'
    },
    {
        id: 598,
        name: 'Outside district',
        level: 'Elementary',
        district: 'Meridian World School Llc',
        County: 'Williamson'
    },
    {
        id: 599,
        name: 'Outside district',
        level: 'Middle or Junior',
        district: 'Meridian World School Llc',
        County: 'Williamson'
    },
    {
        id: 600,
        name: 'Outside district',
        level: 'High School',
        district: 'Meridian World School Llc',
        County: 'Williamson'
    },
    {
        id: 601,
        name: 'Bluebonnet (Bastrop ISD)',
        level: 'Elementary',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 602,
        name: 'Camino Real',
        level: 'Elementary',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 603,
        name: 'Cedar Creek',
        level: 'Elementary',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 604,
        name: 'Emile',
        level: 'Elementary',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 605,
        name: 'Lost Pines',
        level: 'Elementary',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 606,
        name: 'Mina',
        level: 'Elementary',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 607,
        name: 'Red Rock',
        level: 'Elementary',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 608,
        name: 'Colony Oaks',
        level: 'Elementary',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 609,
        name: 'Bastrop',
        level: 'Middle or Junior',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 610,
        name: 'Bastrop Intermediate',
        level: 'Middle or Junior',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 611,
        name: 'Cedar Creek',
        level: 'Middle or Junior',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 612,
        name: 'Cedar Creek Intermediate',
        level: 'Middle or Junior',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 613,
        name: 'Bastrop',
        level: 'High School',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 614,
        name: 'Cedar Creek',
        level: 'High School',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 615,
        name: 'Genesis',
        level: 'High School',
        district: 'Bastrop ISD',
        County: 'Bastrop'
    },
    {
        id: 616,
        name: 'Booker T washington',
        level: 'Elementary',
        district: 'Elgin ISD',
        County: 'Bastrop'
    },
    {
        id: 617,
        name: 'Elgin',
        level: 'Elementary',
        district: 'Elgin ISD',
        County: 'Bastrop'
    },
    {
        id: 618,
        name: 'Neidig',
        level: 'Elementary',
        district: 'Elgin ISD',
        County: 'Bastrop'
    },
    {
        id: 619,
        name: 'Lexington School',
        level: 'Elementary',
        district: 'Elgin ISD',
        County: 'Bastrop'
    },
    {
        id: 620,
        name: 'Harvest Ridge',
        level: 'Elementary',
        district: 'Elgin ISD',
        County: 'Bastrop'
    },
    {
        id: 621,
        name: 'Elgin',
        level: 'Middle or Junior',
        district: 'Elgin ISD',
        County: 'Bastrop'
    },
    {
        id: 622,
        name: 'Elgin',
        level: 'High School',
        district: 'Elgin ISD',
        County: 'Bastrop'
    },
    {
        id: 623,
        name: 'Lexington',
        level: 'Elementary',
        district: 'Lexington ISD',
        County: 'Bastrop'
    },
    {
        id: 624,
        name: 'Lexington',
        level: 'Middle or Junior',
        district: 'Lexington ISD',
        County: 'Bastrop'
    },
    {
        id: 625,
        name: 'Lexington',
        level: 'Elementary',
        district: 'Lexington ISD',
        County: 'Bastrop'
    },
    {
        id: 626,
        name: 'Lexington',
        level: 'Middle or Junior',
        district: 'Lexington ISD',
        County: 'Bastrop'
    },
    {
        id: 627,
        name: 'Elgin',
        level: 'Elementary',
        district: 'McDade ISD',
        County: 'Bastrop'
    },
    {
        id: 628,
        name: 'McDade',
        level: 'Elementary',
        district: 'McDade ISD',
        County: 'Bastrop'
    },
    {
        id: 629,
        name: 'Elgin',
        level: 'Middle or Junior',
        district: 'McDade ISD',
        County: 'Bastrop'
    },
    {
        id: 630,
        name: 'McDade',
        level: 'Middle or Junior',
        district: 'McDade ISD',
        County: 'Bastrop'
    },
    {
        id: 631,
        name: 'Elgin',
        level: 'High School',
        district: 'McDade ISD',
        County: 'Bastrop'
    },
    {
        id: 632,
        name: 'McDade',
        level: 'High School',
        district: 'McDade ISD',
        County: 'Bastrop'
    },
    {
        id: 633,
        name: 'Brown Primary',
        level: 'Elementary',
        district: 'Smithville ISD',
        County: 'Bastrop'
    },
    {
        id: 634,
        name: 'Smithville',
        level: 'Middle or Junior',
        district: 'Smithville ISD',
        County: 'Bastrop'
    },
    {
        id: 635,
        name: 'Smithville',
        level: 'High School',
        district: 'Smithville ISD',
        County: 'Bastrop'
    },
    {
        id: 636,
        name: 'Gonzales',
        level: 'Elementary',
        district: 'Gonzales ISD',
        County: 'Caldwell'
    },
    {
        id: 637,
        name: 'Gonzales East Avenue Primary',
        level: 'Elementary',
        district: 'Gonzales ISD',
        County: 'Caldwell'
    },
    {
        id: 638,
        name: 'Gonzales Primary',
        level: 'Elementary',
        district: 'Gonzales ISD',
        County: 'Caldwell'
    },
    {
        id: 639,
        name: 'Gonzales',
        level: 'Middle or Junior',
        district: 'Gonzales ISD',
        County: 'Caldwell'
    },
    {
        id: 640,
        name: 'Gonzales N Ave Intermediate',
        level: 'Middle or Junior',
        district: 'Gonzales ISD',
        County: 'Caldwell'
    },
    {
        id: 641,
        name: 'Gonzales',
        level: 'High School',
        district: 'Gonzales ISD',
        County: 'Caldwell'
    },
    {
        id: 642,
        name: 'Blanco Vista Elem',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 643,
        name: 'Buda',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 644,
        name: 'Camino Real',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 645,
        name: 'Carpenter Hill',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 646,
        name: 'Elm Grove',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 647,
        name: 'Hemphill',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 648,
        name: 'Kyle',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 649,
        name: 'Laura B Negley',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 650,
        name: 'Ralph Pfluger',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 651,
        name: 'Science Hall',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 652,
        name: 'Sunfield',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 653,
        name: 'Susie Fuentes',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 654,
        name: 'Tobias',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 655,
        name: 'Tom Green',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 656,
        name: 'Uhland',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 657,
        name: 'Jim Cullen',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 658,
        name: 'Armando Chapa',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 659,
        name: 'D J Red Simon',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 660,
        name: 'Eric Dahlstrom',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 661,
        name: 'Laura B Wallace',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 662,
        name: 'McCormick',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 663,
        name: 'R C Barton',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 664,
        name: 'Jack C Hays',
        level: 'High School',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 665,
        name: 'Johnson High School',
        level: 'High School',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 666,
        name: 'Lehman',
        level: 'High School',
        district: 'Hays CISD',
        County: 'Caldwell'
    },
    {
        id: 667,
        name: 'Alma Brewer Strawn',
        level: 'Elementary',
        district: 'Lockhart ISD',
        County: 'Caldwell'
    },
    {
        id: 668,
        name: 'Bluebonnet (Lockhart ISD)',
        level: 'Elementary',
        district: 'Lockhart ISD',
        County: 'Caldwell'
    },
    {
        id: 669,
        name: 'Carver Kindergarten',
        level: 'Elementary',
        district: 'Lockhart ISD',
        County: 'Caldwell'
    },
    {
        id: 670,
        name: 'Clear Fork',
        level: 'Elementary',
        district: 'Lockhart ISD',
        County: 'Caldwell'
    },
    {
        id: 671,
        name: 'Navarro',
        level: 'Elementary',
        district: 'Lockhart ISD',
        County: 'Caldwell'
    },
    {
        id: 672,
        name: 'Navarro (Lockhart ISD)',
        level: 'Elementary',
        district: 'Lockhart ISD',
        County: 'Caldwell'
    },
    {
        id: 673,
        name: 'Plum Creek',
        level: 'Elementary',
        district: 'Lockhart ISD',
        County: 'Caldwell'
    },
    {
        id: 674,
        name: 'Lockhart',
        level: 'Middle or Junior',
        district: 'Lockhart ISD',
        County: 'Caldwell'
    },
    {
        id: 675,
        name: 'Navarro',
        level: 'Middle or Junior',
        district: 'Lockhart ISD',
        County: 'Caldwell'
    },
    {
        id: 676,
        name: 'Lockhart',
        level: 'High School',
        district: 'Lockhart ISD',
        County: 'Caldwell'
    },
    {
        id: 677,
        name: 'Navarro',
        level: 'High School',
        district: 'Lockhart ISD',
        County: 'Caldwell'
    },
    {
        id: 678,
        name: 'Leonard Shanklin',
        level: 'Elementary',
        district: 'Luling ISD',
        County: 'Caldwell'
    },
    {
        id: 679,
        name: 'Luling Primary',
        level: 'Elementary',
        district: 'Luling ISD',
        County: 'Caldwell'
    },
    {
        id: 680,
        name: 'Gilbert Gerdes',
        level: 'Middle or Junior',
        district: 'Luling ISD',
        County: 'Caldwell'
    },
    {
        id: 681,
        name: 'Luling',
        level: 'Middle or Junior',
        district: 'Luling ISD',
        County: 'Caldwell'
    },
    {
        id: 682,
        name: 'Luling',
        level: 'High School',
        district: 'Luling ISD',
        County: 'Caldwell'
    },
    {
        id: 683,
        name: 'Pairie Lea',
        level: 'Elementary',
        district: 'Prairie Lea ISD',
        County: 'Caldwell'
    },
    {
        id: 684,
        name: 'Pairie Lea',
        level: 'Middle or Junior',
        district: 'Prairie Lea ISD',
        County: 'Caldwell'
    },
    {
        id: 685,
        name: 'Pairie Lea',
        level: 'High School',
        district: 'Prairie Lea ISD',
        County: 'Caldwell'
    },
    {
        id: 686,
        name: 'Bowie',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 687,
        name: 'Crockett',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 688,
        name: 'Dezavala',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 689,
        name: 'Hernandez',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 690,
        name: 'Mendez',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 691,
        name: 'Rodriguez (San Marcos ISD)',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 692,
        name: 'Travis',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 693,
        name: 'Dorris Miller',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 694,
        name: 'Goodnight',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 695,
        name: 'Hernandez',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 696,
        name: 'Mendez',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 697,
        name: 'Miller',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 698,
        name: 'Owen Goodnight',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 699,
        name: 'Bowie',
        level: 'High School',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 700,
        name: 'Crockett',
        level: 'High School',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 701,
        name: 'San Marcos',
        level: 'High School',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 702,
        name: 'Travis',
        level: 'High School',
        district: 'San Marcos ISD',
        County: 'Caldwell'
    },
    {
        id: 703,
        name: 'Waelder',
        level: 'Elementary',
        district: 'Waelder ISD',
        County: 'Waelder'
    },
    {
        id: 704,
        name: 'Waelder',
        level: 'Middle or Junior',
        district: 'Waelder ISD',
        County: 'Waelder'
    },
    {
        id: 705,
        name: 'Waelder',
        level: 'High School',
        district: 'Waelder ISD',
        County: 'Waelder'
    },
    {
        id: 706,
        name: 'Allison',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 707,
        name: 'Andrews',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 708,
        name: 'Baldwin',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 709,
        name: 'Baranoff',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 710,
        name: 'Barrington',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 711,
        name: 'Barton Hills',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 712,
        name: 'Bear Creek',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 713,
        name: 'Becker',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 714,
        name: 'Blackshear',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 715,
        name: 'Blanton',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 716,
        name: 'Blazier',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 717,
        name: 'Boone',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 718,
        name: 'Bowie',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 719,
        name: 'Brentwood',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 720,
        name: 'Brooke',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 721,
        name: 'Brown',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 722,
        name: 'Bryker Woods',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 723,
        name: 'Campbell',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 724,
        name: 'Casey',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 725,
        name: 'Casis',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 726,
        name: 'Clayton',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 727,
        name: 'Cook',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 728,
        name: 'Cowan',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 729,
        name: 'Crockett',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 730,
        name: 'Cunningham',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 731,
        name: 'Davis',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 732,
        name: 'Dawson',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 733,
        name: 'Doss (Austin ISD)',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 734,
        name: 'Galindo',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 735,
        name: 'Govalle',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 736,
        name: 'Graham',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 737,
        name: 'Guerrero Thompson',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 738,
        name: 'Gullet',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 739,
        name: 'Harris',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 740,
        name: 'Hart',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 741,
        name: 'HighlandPark',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 742,
        name: 'Hill',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 743,
        name: 'Houston',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 744,
        name: 'Jordan',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 745,
        name: 'Joslin',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 746,
        name: 'Kiker',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 747,
        name: 'Kocurek',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 748,
        name: 'Langford',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 749,
        name: 'Lee',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 750,
        name: 'Linder',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 751,
        name: 'Maplewood',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 752,
        name: 'Mathews',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 753,
        name: 'McBee',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 754,
        name: 'Menchaca',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 755,
        name: 'Mendez',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 756,
        name: 'Metz',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 757,
        name: 'Mills',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 758,
        name: 'Murchison',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 759,
        name: 'Norman-Sims',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 760,
        name: 'Northeast',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 761,
        name: 'Oak Hill',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 762,
        name: 'Oak Springs',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 763,
        name: 'Odom',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 764,
        name: 'Ortega',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 765,
        name: 'Overton',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 766,
        name: 'Padron',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 767,
        name: 'Palm',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 768,
        name: 'Patton',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 769,
        name: 'Pease',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 770,
        name: 'Pecan Springs',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 771,
        name: 'Perez',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 772,
        name: 'Pickle',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 773,
        name: 'Pillow',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 774,
        name: 'Pleasant Hill',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 775,
        name: 'Reilly',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 776,
        name: 'Ridgetop',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 777,
        name: 'Rodriguez',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 778,
        name: 'Sanchez',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 779,
        name: 'Sims',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 780,
        name: 'St Elmo',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 781,
        name: 'Summitt',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 782,
        name: 'Sunset Valley',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 783,
        name: 'Travis',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 784,
        name: 'Travis Hts',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 785,
        name: 'Uphaus Early Childhood',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 786,
        name: 'Walnut Creek',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 787,
        name: 'Webb Primary',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 788,
        name: 'Widen',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 789,
        name: 'Williams',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 790,
        name: 'Winn',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 791,
        name: 'Wooldridge',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 792,
        name: 'Wooten',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 793,
        name: 'Zavala',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 794,
        name: 'Zilker',
        level: 'Elementary',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 795,
        name: 'Bailey',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 796,
        name: 'Bedicheck',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 797,
        name: 'Bertha Sadler Means',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 798,
        name: 'Burnet (Austin ISD)',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 799,
        name: 'Covington',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 800,
        name: 'Dobie (Austin ISD)',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 801,
        name: 'Garcia',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 802,
        name: 'Gorzycki',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 803,
        name: 'Kealing',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 804,
        name: 'Lamar (Austin ISD)',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 805,
        name: 'Lively MS (Fulmore)',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 806,
        name: 'Martin',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 807,
        name: 'Mendez',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 808,
        name: 'Murchison',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 809,
        name: 'O Henry',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 810,
        name: 'Paredes',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 811,
        name: 'Pleasant Hill',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 812,
        name: 'Small',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 813,
        name: 'Travis',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 814,
        name: 'Webb',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 815,
        name: 'Pearce Middle',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 816,
        name: 'Dr. General Garwood Marshall',
        level: 'Middle or Junior',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 817,
        name: 'Akins',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 818,
        name: 'Anderson',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 819,
        name: 'Austin',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 820,
        name: 'Bowie',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 821,
        name: 'Crockett',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 822,
        name: 'Eastside Early College',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 823,
        name: 'Lyndon B Johnson (Austin ISD)',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 824,
        name: 'Mccallum',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 825,
        name: 'Navarro Early College',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 826,
        name: 'Northeast Early college',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 827,
        name: 'Travis',
        level: 'High School',
        district: 'Austin ISD',
        County: 'Hays'
    },
    {
        id: 828,
        name: 'Blanco',
        level: 'Elementary',
        district: 'Blanco ISD',
        County: 'Hays'
    },
    {
        id: 829,
        name: 'Blanco',
        level: 'Middle or Junior',
        district: 'Blanco ISD',
        County: 'Hays'
    },
    {
        id: 830,
        name: 'Blanco',
        level: 'High School',
        district: 'Blanco ISD',
        County: 'Hays'
    },
    {
        id: 831,
        name: 'Arlon R Seay Int',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 832,
        name: 'Bill Brown',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 833,
        name: 'Clear Spring',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 834,
        name: 'Freiheit',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 835,
        name: 'Garden Ridge',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 836,
        name: 'Goodwin Frazier',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 837,
        name: 'Hoffman Lane',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 838,
        name: 'Hwy 46 Area',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 839,
        name: 'Indian Springs',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 840,
        name: 'Johnson Ranch',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 841,
        name: 'Memorial',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 842,
        name: 'Morningside',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 843,
        name: 'Mountain Valley',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 844,
        name: 'Oak Creek',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 845,
        name: 'Rahe Bulverde',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 846,
        name: 'Rebecca Creek',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 847,
        name: 'Specht',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 848,
        name: 'Startzville',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 849,
        name: 'Timberwood Park',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 850,
        name: 'Farias-Spitzer',
        level: 'Elementary',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 851,
        name: 'Arlon R Seay Int',
        level: 'Middle or Junior',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 852,
        name: 'Canyon Intermediate',
        level: 'Middle or Junior',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 853,
        name: 'Canyon Middle',
        level: 'Middle or Junior',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 854,
        name: 'Church Hill',
        level: 'Middle or Junior',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 855,
        name: 'Mountain Valley Middle',
        level: 'Middle or Junior',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 856,
        name: 'New South',
        level: 'Middle or Junior',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 857,
        name: 'Smithson Valley',
        level: 'Middle or Junior',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 858,
        name: 'Spring Branch',
        level: 'Middle or Junior',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 859,
        name: 'Danville',
        level: 'Middle or Junior',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 860,
        name: 'Pieper Ranch Middle',
        level: 'Middle or Junior',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 861,
        name: 'Canyon',
        level: 'High School',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 862,
        name: 'Canyon Lake',
        level: 'High School',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 863,
        name: 'Memorial',
        level: 'High School',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 864,
        name: 'Pieper Ranch High',
        level: 'High School',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 865,
        name: 'Smithson Valley',
        level: 'High School',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 866,
        name: 'Davenport',
        level: 'High School',
        district: 'Comal ISD',
        County: 'Hays'
    },
    {
        id: 867,
        name: 'Dripping Springs',
        level: 'Elementary',
        district: 'Dripping Springs ISD',
        County: 'Hays'
    },
    {
        id: 868,
        name: 'Rooster Springs',
        level: 'Elementary',
        district: 'Dripping Springs ISD',
        County: 'Hays'
    },
    {
        id: 869,
        name: 'Sycamore Springs',
        level: 'Elementary',
        district: 'Dripping Springs ISD',
        County: 'Hays'
    },
    {
        id: 870,
        name: 'Walnut Springs',
        level: 'Elementary',
        district: 'Dripping Springs ISD',
        County: 'Hays'
    },
    {
        id: 871,
        name: 'Cypress Springs',
        level: 'Elementary',
        district: 'Dripping Springs ISD',
        County: 'Hays'
    },
    {
        id: 872,
        name: 'Dripping Springs Middle',
        level: 'Middle or Junior',
        district: 'Dripping Springs ISD',
        County: 'Hays'
    },
    {
        id: 873,
        name: 'Sycamore Springs',
        level: 'Middle or Junior',
        district: 'Dripping Springs ISD',
        County: 'Hays'
    },
    {
        id: 874,
        name: 'Dripping Springs',
        level: 'High School',
        district: 'Dripping Springs ISD',
        County: 'Hays'
    },
    {
        id: 875,
        name: 'Blanco Vista Elem',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 876,
        name: 'Buda',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 877,
        name: 'Camino Real',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 878,
        name: 'Carpenter Hill',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 879,
        name: 'Elm Grove',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 880,
        name: 'Hemphill',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 881,
        name: 'Kyle',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 882,
        name: 'Laura B Negley',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 883,
        name: 'Ralph Pfluger',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 884,
        name: 'Science Hall',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 885,
        name: 'Sunfield',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 886,
        name: 'Susie Fuentes',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 887,
        name: 'Tobias',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 888,
        name: 'Tom Green',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 889,
        name: 'Uhland',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 890,
        name: 'Jim Cullen',
        level: 'Elementary',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 891,
        name: 'Armando Chapa',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 892,
        name: 'D J Red Simon',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 893,
        name: 'Eric Dahlstrom',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 894,
        name: 'Laura B Wallace',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 895,
        name: 'McCormick',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 896,
        name: 'R C Barton',
        level: 'Middle or Junior',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 897,
        name: 'Jack C Hays',
        level: 'High School',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 898,
        name: 'Johnson High School',
        level: 'High School',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 899,
        name: 'Lehman',
        level: 'High School',
        district: 'Hays CISD',
        County: 'Hays'
    },
    {
        id: 900,
        name: 'Lyndon B Johnson',
        level: 'Elementary',
        district: 'Johnson City ISD',
        County: 'Hays'
    },
    {
        id: 901,
        name: 'Lyndon B Johnson',
        level: 'Middle or Junior',
        district: 'Johnson City ISD',
        County: 'Hays'
    },
    {
        id: 902,
        name: 'Lyndon B Johnson (Johnson City ISD)',
        level: 'High School',
        district: 'Johnson City ISD',
        County: 'Hays'
    },
    {
        id: 903,
        name: 'Bowie',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 904,
        name: 'Crockett',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 905,
        name: 'Dezavala',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 906,
        name: 'Hernandez',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 907,
        name: 'Mendez',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 908,
        name: 'Rodriguez (San Marcos ISD)',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 909,
        name: 'Travis',
        level: 'Elementary',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 910,
        name: 'Doris MIller',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 911,
        name: 'Goodnight',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 912,
        name: 'Hernandez',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 913,
        name: 'Mendez',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 914,
        name: 'Miller',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 915,
        name: 'Owen Goodnight',
        level: 'Middle or Junior',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 916,
        name: 'Bowie',
        level: 'High School',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 917,
        name: 'Crockett',
        level: 'High School',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 918,
        name: 'San Marcos',
        level: 'High School',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 919,
        name: 'Travis',
        level: 'High School',
        district: 'San Marcos ISD',
        County: 'Hays'
    },
    {
        id: 920,
        name: 'Blue Hole',
        level: 'Elementary',
        district: 'Wimberley ISD',
        County: 'Hays'
    },
    {
        id: 921,
        name: 'Jacobs Well',
        level: 'Elementary',
        district: 'Wimberley ISD',
        County: 'Hays'
    },
    {
        id: 922,
        name: 'Danforth',
        level: 'Middle or Junior',
        district: 'Wimberley ISD',
        County: 'Hays'
    },
    {
        id: 923,
        name: 'Wimberley',
        level: 'High School',
        district: 'Wimberley ISD',
        County: 'Hays'
    },
    {
        id: 924,
        name: 'Outside district',
        level: 'Elementary',
        district: 'Katherine Anne Porter',
        County: 'Hays'
    },
    {
        id: 925,
        name: 'Outside district',
        level: 'Middle or Junior',
        district: 'Katherine Anne Porter',
        County: 'Hays'
    },
    {
        id: 926,
        name: 'Outside district',
        level: 'High School',
        district: 'Katherine Anne Porter',
        County: 'Hays'
    },
    {
        id: 927,
        name: 'Outside district',
        level: 'Elementary',
        district: 'Ki Charter Academy',
        County: 'Hays'
    },
    {
        id: 928,
        name: 'Outside district',
        level: 'Middle or Junior',
        district: 'Ki Charter Academy',
        County: 'Hays'
    },
    {
        id: 929,
        name: 'Outside district',
        level: 'High School',
        district: 'Ki Charter Academy',
        County: 'Hays'
    },
    {
        id: 930,
        name: 'Outside district',
        level: 'Elementary',
        district: 'Texas preparatory School',
        County: 'Hays'
    },
    {
        id: 931,
        name: 'Outside district',
        level: 'Middle or Junior',
        district: 'Texas preparatory School',
        County: 'Hays'
    },
    {
        id: 932,
        name: 'Outside district',
        level: 'High School',
        district: 'Texas preparatory School',
        County: 'Hays'
    }
];
